import { Box, Stack, Typography, Chip } from "@mui/material";
import { buildFinalUrlSuffixPreview } from '~/shared/utils/buildFinalUrlSuffixPreview';

export const SettingsResult = ({ settings, budgetRange, suffixPreview }: any) => {
  const resolvedSuffixPreview =
    suffixPreview ||
    buildFinalUrlSuffixPreview({
      appendTag: settings.append_tag,
      customUtm: settings.custom_utm,
      finalUrlSuffix: settings.final_url_suffix,
    });
  const businessNameEntries = Object.entries(settings.business_names || {});
  const compactItems = [
    {
      label: 'Заголовки',
      value: `От: ${settings.headlines.min} до ${settings.headlines.max}`,
    },
    {
      label: 'Бюджет шаблона',
      value: budgetRange
        ? `От: ${budgetRange.from} до ${budgetRange.to} ${budgetRange.baseCurrency}`
        : 'Не задан',
    },
    {
      label: 'Описания',
      value: `От: ${settings.descriptions.min} до ${settings.descriptions.max}`,
    },
    {
      label: 'Логотипы',
      value: `От: ${settings.logo.min} до ${settings.logo.max}`,
    },
    {
      label: 'Режим',
      value: settings.mode === 'marketing_image'
        ? `Marketing Image, от: ${settings.marketing_image.min} до ${settings.marketing_image.max}`
        : `Marketing Link, от: ${settings.marketing_link.min} до ${settings.marketing_link.max}`,
      isChip: true,
    },
  ];

  return (
    <Stack sx={{ flex: 1, gap: 0.75 }}>
      <Typography fontWeight={600}>Business name: </Typography>
      {businessNameEntries.length ? (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              md: 'repeat(2, minmax(0, 1fr))',
            },
            columnGap: 1.5,
            rowGap: 0.35,
          }}
        >
          {businessNameEntries.map(([domain, value]) => (
            <Typography
              key={domain}
              variant="body2"
              sx={{
                minWidth: 0,
                lineHeight: 1.35,
              }}
            >
              <Box
                component="span"
                sx={{
                  fontWeight: 500,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {domain}
                :{' '}
              </Box>
              <Box component="span" sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>
                {String(value).trim() || 'Авто из домена'}
              </Box>
            </Typography>
          ))}
        </Box>
      ) : (
        <Typography>Авто из домена</Typography>
      )}
      <Typography>
        <span style={{ fontWeight: 600 }}>Автоматически вставлять тег конверсии: </span>
        {settings.append_tag ? 'Да' : 'Нет'}
      </Typography>
      <Typography>
        <span style={{ fontWeight: 600 }}>Тег конверсии: </span>
        {settings.custom_utm?.trim() || (settings.append_tag ? 'Будет подставлен автоматически' : 'Не задан')}
      </Typography>
      <Typography>
        <span style={{ fontWeight: 600 }}>Final URL suffix: </span>
        {settings.final_url_suffix?.trim() || 'Не задан'}
      </Typography>
      <Typography fontWeight={600}>Итоговый suffix</Typography>
      <Typography
        sx={{
          fontFamily: 'monospace',
          fontSize: '0.9rem',
          wordBreak: 'break-all',
        }}
      >
        {resolvedSuffixPreview}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            md: 'repeat(2, minmax(0, 1fr))',
          },
          columnGap: 2,
          rowGap: 1,
          mt: 0.5,
        }}
      >
        {compactItems.map((item) => (
          <Box key={item.label} sx={{ minWidth: 0 }}>
            {item.isChip ? (
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Typography fontWeight={600}>
                  {item.label}
                </Typography>
                <Chip
                  label={settings.mode === 'marketing_image'
                    ? 'Marketing Image'
                    : 'Marketing Link'}
                  color="primary"
                  size="small"
                />
                <Typography variant="body2">{item.value}</Typography>
              </Stack>
            ) : (
              <Typography variant="body2">
                <Box component="span" sx={{ fontWeight: 600 }}>
                  {item.label}
                  :{' '}
                </Box>
                {item.value}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
